import { connect } from "react-redux";
import { put } from "redux-saga/effects";
import { createAction, createReducer } from "redux-delta";
import { utcTimestamp, waitFor } from "../../utils/time";

export const setTimestamp = createAction("SET_TIMESTAMP");
export const timestamp = createReducer({ value: utcTimestamp() }, [
  setTimestamp.case((_, value) => ({ value }))
]);

export const selector = ({ timestamp }) => timestamp.value;

export const withTimestamp = connect(
  state => ({ timestamp: selector(state) }),
  { setTimestamp }
);

export default function*(timer = 1000) {
  while (true) {
    yield put(setTimestamp(utcTimestamp()));
    yield waitFor(Math.min(timer, 1000));
  }
}



// WEBPACK FOOTER //
// ./src/store/timestamp/index.js